"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVParser = void 0;
var TDNode_1 = require("../TDNode");
var CSVOption_1 = require("./CSVOption");
var StringBuilder_1 = require("../core/StringBuilder");
var TreeDoc_1 = require("../TreeDoc");
var __1 = require("..");
var ClassUtil_1 = require("../core/ClassUtil");
var SPACE_CHARS = " \r";
var CSVParser = /** @class */ (function () {
    function CSVParser() {
    }
    CSVParser.get = function () { return CSVParser.instance; };
    CSVParser.parse = function (src, opt) {
        return CSVParser.get().parse(src, opt);
    };
    CSVParser.prototype.parse = function (src, opt, root) {
        if (opt === void 0) { opt = new CSVOption_1.CSVOption(); }
        if (root === void 0) { root = new TreeDoc_1.TreeDoc('root').root; }
        if (typeof src === 'string')
            src = new __1.StringCharSource(src);
        var fields;
        root.setType(TDNode_1.TDNodeType.ARRAY);
        if (opt.includeHeader) {
            fields = this.readNonEmptyRecord(src, opt).map(function (f) { return "" + f; });
            if (fields.length === 0)
                return root;
            if (fields[0] === TDNode_1.TDNode.COLUMN_KEY)
                root.setType(TDNode_1.TDNodeType.MAP);
        }
        while (!src.isEof()) {
            if (!src.skipChars(SPACE_CHARS))
                break;
            this.readRecordToTDNode(src, opt, root, fields);
        }
        return root;
    };
    CSVParser.prototype.readRecordToTDNode = function (src, opt, root, fields) {
        var row = new TDNode_1.TDNode(root.doc).setType(fields == null ? TDNode_1.TDNodeType.ARRAY : TDNode_1.TDNodeType.MAP);
        row.setStart(src.getBookmark());
        var i = 0;
        while (!src.isEof() && src.peek() !== opt.recordSep) {
            if (!src.skipChars(SPACE_CHARS))
                break;
            var start = src.getBookmark();
            var val = this.readField(src, opt);
            var key = void 0;
            if (fields != null) {
                if (i >= fields.length)
                    throw src.createParseRuntimeException("The row has more columns than headers");
                key = fields[i++];
                if (key === TDNode_1.TDNode.COLUMN_KEY) {
                    row.setKey(val.toString());
                    continue;
                }
            }
            var field = row.createChild(key).setValue(val);
            field.setStart(start).setEnd(src.getBookmark());
        }
        row.setEnd(src.getBookmark());
        if (row.hasChildren())
            root.addChild(row);
        if (!src.isEof())
            src.read(); // Skip the recordSep
    };
    CSVParser.prototype.readNonEmptyRecord = function (src, opt) {
        while (!src.isEof()) {
            var res = this.readRecord(src, opt);
            if (res.length > 0)
                return res;
        }
        return [];
    };
    CSVParser.prototype.readRecord = function (src, opt) {
        var result = [];
        while (!src.isEof() && src.peek() !== opt.recordSep) {
            if (!src.skipChars(SPACE_CHARS))
                break;
            result.push(this.readField(src, opt));
        }
        if (!src.isEof())
            src.read(); // Skip the recordSep
        return result;
    };
    CSVParser.prototype.readField = function (src, opt) {
        var sb = new StringBuilder_1.StringBuilder();
        if (src.isEof())
            return sb.toString();
        var isString = false;
        if (src.peek() !== opt.quoteChar) { // Read non-quoted string
            sb.append(src.readUntilTerminator(opt._fieldAndRecord).trim());
        }
        else { // Read quoted string
            isString = true;
            src.skip();
            while (!src.isEof()) {
                // Not calling getBookmark() to avoid clone an object
                var pos = src.bookmark.pos;
                var line = src.bookmark.line;
                var col = src.bookmark.col;
                src.readUntilTerminatorToString(sb, opt.quoteChar);
                if (src.isEof())
                    throw src.createParseRuntimeException("Can't find matching quote at position:" + pos + ";line:" + line + ";col:" + col);
                src.skip();
                if (src.isEof())
                    break;
                if (src.peek() === opt.quoteChar) {
                    sb.append(opt.quoteChar);
                    src.skip();
                }
                else {
                    break;
                }
            }
            src.skipChars(" \t");
        }
        if (!src.isEof() && src.peek() === opt.fieldSep)
            src.skip(); // Skip fieldSep
        var str = sb.toString();
        return isString ? str : ClassUtil_1.ClassUtil.toSimpleObject(str);
    };
    CSVParser.instance = new CSVParser();
    return CSVParser;
}());
exports.CSVParser = CSVParser;
//# sourceMappingURL=CSVParser.js.map